<template>
    <div v-bind="$attrs" :class="['column', {['is-' + size]: size}]">
        <slot></slot>
    </div>
</template>

<script>
  export default {
    name: "GridColumn",
    props: {
      /**
       * Note: This size should be 1-12
       */
      size: {
        type: Number,
        default: 0,
      },
    },
  }
</script>

<style scoped>

</style>
